export const NIVO_COMMON = {
  axes: {
    legendPosition: 'middle' as const,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    truncateTickAt: 0,
  },
  theme: {
    axis: {
      legend: {
        text: {
          fontFamily:
            'Calibre-Medium, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: 14,
        },
      },
      ticks: {
        text: {
          fontFamily:
            'Calibre-Regular, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: 14,
        },
      },
    },
    labels: {
      text: {
        fontFamily:
          'Calibre-Regular, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontSize: 18,
      },
    },
  },
} as const;

export const NIVO_COMMON_LINE = {
  ...NIVO_COMMON,
  enableArea: true as const,
  pointBorderColor: { from: 'serieColor' },
  pointBorderWidth: 0,
  pointColor: { from: 'color', modifiers: [] },
  pointSize: 10,
} as const;
